export default "__VITE_ASSET__JYIsmtqx__"